import { Component } from '@angular/core';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';

@Component({
  selector: 'app-no-cdr-required',
  imports: [BackgroundDecorationComponent],
  templateUrl: './no-cdr-required.component.html',
  styleUrl: './no-cdr-required.component.scss',
  standalone: true,
})
export class NoCdrRequiredComponent {}
